module.exports = __webpack_public_path__ + "img/Baptist MD Anderson.107fd6e5.png";